import { useEffect, useState } from 'react';
import { ISelectBoxOptions, SelectBox } from 'devextreme-react/ui/select-box';
import { useAuth } from 'contexts';
import { IProj } from 'types/datatypes/IProj';


interface SelectProjectProps extends ISelectBoxOptions {
  onValueChange: (value: string) => void;
  availableOnly?:boolean;
  items?: IProj[];//={projects.available}
  value:IProj|string;//={doc?.proj ?? projects.default.ref}
  label?:string;
}

export const SelectProject = ({ value, onValueChange, availableOnly = false, label, ...rest }:SelectProjectProps) => {
  const { projects } = useAuth();
  const inpValue = (typeof value === 'string') ? projects.byRef(value) : value;
  const [ _proj, setProj ] = useState<IProj>(inpValue ?? projects.default);

  useEffect(() => {
    setProj(inpValue ?? projects.default);
  }, [ projects.default, value ]);

  const handleValueChange = (e:any) => {
    const proj = projects.byRef(e.value)!;
    if (inpValue !== proj ) {
      onValueChange(e.value);
      setProj(proj);
    }
  };

  const selectItems = availableOnly ? projects.available : projects.items;
  const splitItem = selectItems?.find(i => i.id === 'split');
  if (splitItem) splitItem.visible = false;

  return (
    <SelectBox
      {...rest}
      items={selectItems}
      displayExpr='name'
      valueExpr='ref'
      onValueChanged={handleValueChange}
      value={_proj?.ref}
      placeholder=''
      hint='тип замовлення'
      label={label ?? 'Тип замовлення'}
    />
  );
};
